<template>
    <div class="gateway">
        <div class="topCont">
            <div class="left">
                <el-button type="primary" @click="toRefresh">今天</el-button>
                <span class="el-icon-arrow-left" @click="prevWeek"></span>
                <span class="el-icon-arrow-right" @click="nextWeek"></span>
            </div>
            <p>{{currentDate}}</p>
            <div class="right">
<!--                <el-select v-model="regionValue" placeholder="请选择" @change="getRegionTableData">-->
<!--                    <el-option v-for="(item,index) in regionTreeList"-->
<!--                               :key="index"-->
<!--                               :label="item.name"-->
<!--                               :value="item.id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
            </div>
        </div>
        <div class="mainCont">
            <div class="tables">
                <el-table
                        v-loading="loading"
                        :data="tabRows"
                        border
                        :cell-style="cellStyle"
                        @cell-click="lookDetail"
                        :key="timestamp"
                        style="border: 1px solid #cccccc">
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="name"
                            label=""
                            width="40">
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            v-for="propitem in tabHeader.columns"
                            :key="propitem"
                            :prop="propitem"
                            :label="tabHeader.columnMap[propitem]">
                        <template slot-scope="scope">
                            <ul class="everyPlace">
                                <li v-for="(item,index) in scope.row.data[propitem]"
                                    :key="index">
                                    <p>{{item.businessName}}</p>
                                    <span><em>[{{item.opentime.slice(0,5)}}]</em><em>[{{item.fieldName}}]</em></span>
                                </li>
                            </ul>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog
                :title="detailTopTime"
                :visible.sync="dialogVisible"
                width="60%">
            <span>
                <div class="top" v-for="(item,index) in detailArr" :key="index">
                    <p>
                        <i>{{item.businessName}}</i>
                        <em>{{item.applicant}}</em>
                    </p>
                    <p>
                        <em>{{item.opentime}} 【{{item.fieldName}}】</em>
                        <em>预约来源：{{item.source}}</em>
                    </p>
                </div>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {formatDate} from '@/utils/index'
    import { mapState } from 'vuex'
    export default {
        data(){
            return {
                regionValue:'',
                regionOptions:[],
                currentDate:'',
                detailArr:[],
                detailTopTime:'',
                tabHeader: {
                  columns: [],
                  columnMap: {},
                },
                tabRows: [],
                timestamp: "1",
                dialogVisible:false,
                loading:false
            }
        },
        created(){
            // this.setDate(new Date());
            let date=new Date;
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            this.currentDate = y + '年' + m + '月';
            if (this.$route.query.regionCode) {
                this.regionValue = this.$route.query.regionCode;
                this.getAllTableData();
            }
            this.$store.dispatch('region/getRegionTree','');
        },
        // mounted(){
        //     this.getAllTableData();
        // },
        computed:{
            ...mapState({
                regionTreeList:(state) => state.region.regionTreeList,
            })
        },
        methods:{
            cellStyle({ row, column, rowIndex, columnIndex }) {
              if (columnIndex<1){
                return 'border-right:1px solid #cccccc';
              }
              let date = new Date().toLocaleDateString();
              let columnDate=new Date(column.property);
              if (date == columnDate.toLocaleDateString()) {
                return 'background:rgba(255,127,0,.2);';
              }
              if(rowIndex === 0){
                    if (columnIndex === 1 || columnIndex === 3 || columnIndex === 5 || columnIndex === 7) {
                        // 指定列号
                        return 'background:#eeeeee';
                    } else {
                        return 'background:rgba(245,245,245,1)';
                    }
                }else{
                    if (columnIndex === 2 || columnIndex === 4 || columnIndex === 6) {
                        // 指定列号
                        return 'background:#eeeeee';
                    } else {
                        return 'background:rgba(245,245,245,1)';
                    }
                }
            },
            getRegionTableData(){
                this.getAllTableData();
            },
            toRefresh(){
                this.tabHeader={}
                this.getAllTableData();
            },
            lookDetail(row,column,cell,event){
              this.detailArr = row.data[column.property];
              this.detailTopTime = row.data[column.property][0].openDay;
                this.dialogVisible = true;
            },
            prevWeek(){
              let filter = "";
              if (this.tabHeader.columns && this.tabHeader.columns.length > 0) {
                let datestr = this.tabHeader.columns[0];
                let starts = new Date(datestr);
                starts = this.addDate(starts, -7)
                filter = formatDate(starts,"YYYY-MM-dd")
              }
              this.getAllTableData(filter);
            },
            nextWeek(){
              let filter = "";
              if (this.tabHeader.columns && this.tabHeader.columns.length > 0) {
                let datestr = this.tabHeader.columns[this.tabHeader.columns.length - 1];
                let starts = new Date(datestr);
                starts = this.addDate(starts, 1)
                filter = formatDate(starts,"YYYY-MM-dd")
              }
              this.getAllTableData(filter);
            },
            addDate(date,n){
                date.setDate(date.getDate()+n);
                return date;
            },
            getAllTableData(startdate){
              if (!this.regionValue) {
                this.regionValue = this.regionTreeList[0] ? this.regionTreeList[0].id : '';
              }
              let filter = {startdate: startdate, regionCode: this.regionValue, fieldType: '1'}
              this.loading = true;
              this.$http.post('/field/apply/reportview', JSON.stringify(filter)).then(({data}) => {
                this.tabHeader = data.data.header || {};
                this.tabRows = data.data.rows || [];
                this.timestamp = new Date().getTime().toString(10);
                this.loading = false;
              });
            }
        }
    }
</script>
<style lang="scss" scoped>
.gateway{
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 10px;
    display:flex;
    flex-direction:column;
    align-items:center;
    .topCont{
        width: 100%;
        height: 50px;
        margin: 0 0 5px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left{
            display:flex;
            .el-button--medium{
                width: 100px;
            }
            span{
                width: 36px;
                height: 36px;
                background: #ffffff;
                border: 1px solid #cccccc;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 20px;
                cursor: pointer;
            }
            span:hover{
                color: #ffffff;
                background: #004798;
                border: 0;
            }
        }
        p{
            font-size: 16px;
            font-weight: 600;
        }
        .el-button--primary{
            background: #004798;
            border: 0;
        }
        /deep/.el-select .el-input__inner:focus{
            border-color: #004798;
        }
    }
    .mainCont{
        width: 100%;
        flex: 1;
        display:flex;
        align-items: center;
        justify-content:center;
        .tables{
            width: 100%;
            height:100%;
            /deep/.el-table__header-wrapper{
                border-bottom: 1px solid #cccccc;
                th{
                    border-right: 1px solid #cccccc;
                }
            }
            /deep/.el-table--enable-row-transition .el-table__body td{
                vertical-align: top;
            }
            .everyPlace{
                width: 100%;
                min-height:390px;
                li{
                    width: 100%;
                    height: 70px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;

                   p{
                       text-align: left;
                       overflow: hidden;
                       text-overflow:ellipsis;
                       white-space: nowrap;
                       cursor: pointer;
                   }
                   span{
                       display: flex;
                       em{
                           font-size: 12px;
                           font-style: normal;
                           cursor: pointer;
                       }
                       em:nth-child(1){
                           width: 30%;
                           text-align: left;
                       }
                       em:nth-child(2){
                           width: 70%;
                           text-align: right;
                       }
                   }
                }
               /*li:nth-child(2n){*/
               /*    background: #cccccc;*/
               /*}*/
            }
            .everyPlace:nth-child(2n){
                 li:nth-child(3n){
                     background: #cccccc;
                 }
            }
        }

    }
    .el-dialog__wrapper{
        .top{
            display: flex;
            justify-content:space-between;
            padding: 0 10px;
            margin-bottom: 10px;
            border-radius: 5px;
            border:1px solid #004798;
            p{
                width: 50%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items:center;
                i,em{
                    width: 100%;
                    font-style: normal;
                    margin: 5px 0;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    word-break: break-all;
                    overflow: hidden;
                }
            }
            p:nth-child(1){
                width: 70%;
            }
            p:nth-child(2){
              width:30%;
              em{
                  width: 100%;
                  text-align: right;
              }
              em:nth-child(2){
                  padding-right: 10px;
              }
            }
        }
        .bot{
            display: flex;
            justify-content: space-between;
            p{
                display: flex;
                flex-direction: column;
                em{
                    font-style: normal;
                }
            }

        }
    }
}
@media screen and (max-width: 1360px){
    .gateway{
        width: 1360px;
    }
}
@media screen and (max-width: 1200px){
    .gateway{
        width: 1200px;
    }
}
@media screen and (max-width: 1100px){
    .gateway{
        width: 1100px;
    }
}
/*@media screen and (max-width: 1600px){*/
/*    .gateway{*/
/*        .topCont{*/
/*            width: 1500px;*/
/*            height: 60px;*/
/*        }*/
/*        .mainCont{*/
/*            .tables{*/
/*                width: 1500px;*/
/*            }*/
/*        }*/
/*    }*/
/*}*/
/*@media screen and (max-width: 1440px){*/
/*    .gateway{*/
/*        .topCont{*/
/*            width: 1340px;*/
/*            height: 60px;*/
/*        }*/
/*        .mainCont{*/
/*            .tables{*/
/*                width: 1340px;*/
/*            }*/
/*        }*/
/*    }*/
/*}*/
</style>